import MuiButton from "@mui/material/Button";
import { ThemeProvider } from '@mui/material/styles';
import { theme } from '../Theme';

const MenuButton = (props) => <ThemeProvider theme={theme}><MuiButton variant="text" {...props} /></ThemeProvider>;

export default MenuButton;
